import { Swiper } from 'swiper/bundle';

var featureSliders = document.querySelectorAll('.slider-feature');

featureSliders.forEach((featureSlider) => {
  initializeSwiper(featureSlider);
});

function initializeSwiper(swiperInstance) {
  var sliderFeatureNav = swiperInstance.querySelector('.slider-nav');
  var sliderFeature = new Swiper(swiperInstance, {
    effect: 'fade',
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    slidesPerView: 1,
    slideActiveClass: 'slider-item-active',
  });

  sliderFeature.on('slideChangeTransitionStart', function () {
    if (sliderFeature.slides[sliderFeature.realIndex].classList.contains('has-video')) {
      var video = sliderFeature.slides[sliderFeature.realIndex].getElementsByTagName('video');
      video[0].play();
    }
  });

  sliderFeature.on('slideChange', function () {
    Array.from(sliderFeature.slides).forEach(function (slide) {
      if (slide.classList.contains('has-video')) {
        var video = slide.getElementsByTagName('video');
        video[0].classList.add('pause');
        video[0].pause();
      }
    });

    var navElements = swiperInstance.querySelectorAll('.slider-nav-item');
    navElements.forEach(function (navElement) {
      navElement.classList.remove('active');
      if (navElement.dataset.slideIndex == sliderFeature.activeIndex) {
        navElement.classList.add('active');
      }
    });
  });

  sliderFeatureNav.querySelectorAll('li > a').forEach(function (el, key) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      swiperInstance.setAttribute('data-slider-autoplay', 'false');
      el.parentNode.classList.add('active');
      sliderFeature.slideTo(el.parentNode.dataset.slideIndex);

      sliderFeatureNav.querySelectorAll('li').forEach(function (ell, els) {
        if (key !== els) {
          ell.classList.remove('active');
        }
      });
    });
  });
}

export { initializeSwiper };
